function toggleExclusion() {
  const exclusionsActive = $(this).data('active');

  if (exclusionsActive) {
    $('.exclusion-highlight').each(function removeExclusionHighlight() {
      $(this).removeClass('exclusion-highlight');
      $(this).addClass('exclusion-highlight-none');
    });

    $(this).data('active', false);
  } else {
    $('.exclusion-highlight-none').each(function addExclusionHighlight() {
      $(this).removeClass('exclusion-highlight-none');
      $(this).addClass('exclusion-highlight');
    });

    $(this).data('active', true);
  }
}

export default toggleExclusion;
